import { useMutation, useQueryClient, QueryKey } from 'react-query'

export type KeyInputToInvalidate =
  | string
  | string[]
  | (string | string[])[]
  | Record<string, string>
  | Record<string, string>[]

export const useInvalidateOnSuccessMutation = <
  TData = unknown,
  TError = unknown,
  TVariables = any,
  TContext = unknown
>(
  keyInputToInvalidate: KeyInputToInvalidate,
  mutationFn: (variables: TVariables) => Promise<TData>,
  mutationKey?: string | string[],
) => {
  const queryClient = useQueryClient()
  return useMutation<TData, TError, TVariables, TContext>(mutationFn, {
    onSuccess: () => {
      const keys = (Array.isArray(keyInputToInvalidate)
        ? keyInputToInvalidate
        : [keyInputToInvalidate]) as QueryKey[]

      keys.forEach((key) => queryClient.invalidateQueries(key))
    },
    mutationKey,
  })
}
